import React, { useState } from 'react';
import styles from './styles.module.scss';
import './styles.css';
import CustomInput from '../../../../../components/CustomInput';
import Button from '../../../../../components/Button';
import Flex from '../../../../../components/Flex';
import { commonImages, operatorImages } from '../../../../../assets/images';
import strings from '../../../../../globalization';
import DateRangePicker from 'react-daterange-picker';
import 'react-daterange-picker/dist/css/react-calendar.css';
import moment from 'moment';

const TransactionReportForm = ({ email, emailError, dates, onChange, onClick }) => {
    const [showDate, setShowDate] = useState(false);

    const onSelect = selectedDates => {
        onChange('date', {
            startDate: moment(selectedDates.start).format('MM-DD-YYYY'),
            endDate: moment(selectedDates.end).format('MM-DD-YYYY'),
            dates: selectedDates,
        });
        setShowDate(false);
    };

    const toggleDate = () => {
        setShowDate(!showDate);
    };

    const formatDate = date => moment(date).format('MMM Do YY');

    // Calculate minimum date (6 months ago from today)
    const minimumDate = moment().subtract(6, 'months').toDate();
    const maximumDate = new Date();

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                {/* Header */}
                <div className={styles.header}>
                    <h1 className={styles.title}>Transaction Report</h1>
                    <p className={styles.subtitle}>
                        Enter email address and select date range to generate transaction report (maximum 6 months old)
                    </p>
                </div>

                {/* Form Card */}
                <div className={styles.formCard}>
                    <div className={styles.formGrid}>
                        {/* Email Input */}
                        <div className={styles.inputContainer}>
                            <CustomInput
                                inputLable="Email Address *"
                                placeholder="Enter email address"
                                value={email}
                                onTextChange={value => onChange('email', value)}
                                error={emailError}
                                required={true}
                            />
                        </div>

                        {/* Date Range Picker */}
                        <div className={styles.inputContainer}>
                            <label className={styles.inputLabel}>Date Range *</label>
                            <div className={styles.dateWrapper}>
                                <Button
                                    onClick={toggleDate}
                                    buttonStyle="secondary"
                                    label={dates ? `${formatDate(dates.start)} - ${formatDate(dates.end)}` : 'Select Date Range'}
                                    className={styles.dateBtn}
                                />
                                {showDate ? (
                                    <div className={styles.datePicker}>
                                        <DateRangePicker
                                            numberOfCalendars={1}
                                            selectionType="range"
                                            onSelect={onSelect}
                                            className={styles.dateRange}
                                            value={dates}
                                            singleDateRange={true}
                                            minimumDate={minimumDate}
                                            maximumDate={maximumDate}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className={styles.buttonContainer}>
                        <Button
                            label={
                                <Flex direction="row" className={styles.buttonContent}>
                                    <span>Send Report</span>
                                </Flex>
                            }
                            buttonStyle="primary"
                            onClick={() => onClick('sendReport')}
                            className={styles.submitButton}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const SuccessPage = ({ reportData, onClick }) => {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.statusCard}>
                    <div className={styles.statusIcon}>
                        <img
                            src={operatorImages.successIcon}
                            alt="Success"
                            className={styles.iconImage}
                        />
                    </div>
                    <h2 className={styles.statusTitle}>Report Sent Successfully!</h2>
                    <p className={styles.statusMessage}>
                        The transaction report has been sent to the provided email address.
                        Please check your inbox.
                    </p>
                    <div className={styles.statusActions}>
                        <Button
                            label="Okay"
                            buttonStyle="primary"
                            onClick={() => onClick('backToForm')}
                            className={styles.actionButton}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const FailurePage = ({ onClick }) => {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.statusCard}>
                    <div className={styles.statusIcon}>
                        <img
                            src={commonImages.errorIcon}
                            alt="Error"
                            className={styles.iconImage}
                        />
                    </div>
                    <h2 className={styles.statusTitle}>Failed to Send Report</h2>
                    <p className={styles.statusMessage}>
                        There was an error sending the transaction report. Please check your
                        inputs and try again.
                    </p>
                    <div className={styles.statusActions}>
                        <Button
                            label="Try Again"
                            buttonStyle="primary"
                            onClick={() => onClick('retry')}
                            className={styles.actionButton}
                        />
                        <Button
                            label="Okay"
                            buttonStyle="outline"
                            onClick={() => onClick('backToForm')}
                            className={styles.actionButton}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default function Desktop(props) {
    const { showSuccess, showFailure } = props;

    if (showSuccess) {
        return <SuccessPage {...props} />;
    }

    if (showFailure) {
        return <FailurePage {...props} />;
    }

    return <TransactionReportForm {...props} />;
}

